import React, { useState } from "react";
import { ChatWidgetButton } from "./ChatWidgetButton";
import { ChatModal } from "./ChatModal";

export const ChatbotWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <ChatModal isOpen={isOpen} onClose={handleClose} />
      <ChatWidgetButton isOpen={isOpen} onToggle={handleToggle} />
    </>
  );
};

export default ChatbotWidget;
